import React from "react";
import { CascadeSelect } from 'primereact/cascadeselect';
import CSBaseControl from "./CSBaseControl";

class CSCascadeSelect extends CSBaseControl {
    constructor(props) {
        super(props);

        this.state = {
            mValue     : props.mValue || null,
            mClassName : props.pClassName || 'form-control',
            mOptions   : props.mOptions || []
        };

        this.cfHandleChange = this.cfHandleChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mValue !== this.props.mValue) {
            this.setState({ mValue: this.props.mValue });
        }
        if (prevProps.mOptions !== this.props.mOptions) {
            this.setState({ mOptions: this.props.mOptions });
        }
    }

    cfHandleChange(event) {
        const newValue = event.value;
        this.setState({ mValue: newValue });
        
        if (this.props.process_change_) {
            this.props.process_change_(newValue);
        }
    }

    render() {
        const {
            pLabel,
            pRequired,
            pDisabled,
            pPlaceholder,
            pStyle,
            pWidth,
            pHeight,
            pFilter,
            pFilterMatchMode,
            pShowClear,
            pChangeOnSelect,
            pOptionLabel = 'name',    // Default to 'name' if not specified
            pOptionValue = 'code',    // Default to 'code' if not specified
            pOptionItems = 'items'    // Default to 'items' if not specified
        } = this.props;

        const labelWidth = pWidth ? pWidth : '100px';
        const controlStyle = {
            width: pWidth,
            height: pHeight,
            ...pStyle
        };

        return (
            <div className="cs-control-container" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                {pLabel && (
                    <label style={{ width: labelWidth, marginRight: '10px' }}>
                        {pLabel}
                        {pRequired && <span style={{ color: 'red' }}> *</span>}
                    </label>
                )}
                <CascadeSelect
                    value               = {this.state.mValue}
                    options             = {this.state.mOptions}
                    onChange            = {this.cfHandleChange}
                    className           = {this.state.mClassName}
                    style               = {controlStyle}
                    disabled            = {pDisabled}
                    placeholder         = {pPlaceholder}
                    filter              = {pFilter}
                    filterMatchMode     = {pFilterMatchMode}
                    showClear           = {pShowClear}
                    changeOnSelect      = {pChangeOnSelect}
                    optionLabel         = {pOptionLabel}
                    optionValue         = {pOptionValue}
                    optionGroupChildren = {pOptionItems}
                />
            </div>
        );
    }
}

export default CSCascadeSelect; 